var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-entry"},[(_vm.hasInternalNotes)?_c('notes',{attrs:{"html":_vm.type.internalNotes}}):_vm._e(),(!_vm.loading)?_c('type-view',{attrs:{"type":_vm.type}}):_c('div',{staticClass:"center-frame"},[_c('loading-spinner',{attrs:{"size":_vm.LoadingSpinnerSize.Big}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }